import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';
import { StorageService } from './storage.service';

const USER_KEY = 'currentUser';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User | undefined;

  constructor(private storage: StorageService) {}

  public currentUser(): any {
    return this.storage.get(USER_KEY);
  }

  login(email: string, password: string) {
    return getFirebaseBackend()
      .loginUser(email, password)
      .then((response: any) => response);
  }

  register(email: string, password: string) {
    return getFirebaseBackend()
      .registerUser(email, password)
      .then((response: any) => response);
  }

  resetPassword(email: string) {
    return getFirebaseBackend()
      .forgetPassword(email)
      .then((response: any) => response.data);
  }

  logout() {
    this.storage.remove(USER_KEY);
    getFirebaseBackend().logout();
  }
}
